import LoggedInBoilerplate from "../LoggedInBoilerplate";
import styled from "styled-components";
import TabularAssignmentHistory from "../../../customUiForCs/tabularAssignmentHistory/TabularAssignmentHistory";
import DailyResponsibility from "../../../customUiForCs/dailyResponsibility/DailyResponsibility";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  align-items: center;
  margin-top: 50px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Row2Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

const DataColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  overflow: visible;

`;

export default function AttendancePage() {
  let title1 = "La page";
  let title2 = "de nomenclature";

  return (
    <PermissionGuard permissionName={"nomenclaturePermissions"} action={"VIEW"}>
      <LoggedInBoilerplate titleLine1={title1} titleLine2={title2}>
        <Column>
          <TabularAssignmentHistory disableTitle={true} />
        </Column>
      </LoggedInBoilerplate>
    </PermissionGuard>
  );
}
